<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="990"
    persistent
  >
    <v-card>
      <v-toolbar
        dense
        light
        class="grey lighten-2"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ dialogTitle }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          small
          depressed
          color=""
          @click="handleCancel"
          :disabled="isLoading"
        >
          {{ $t('m.cancel') }}
        </v-btn>
        <v-btn
          small
          depressed
          color="primary"
          class="ml-6"
          @click="save"
          :disabled="isLoading"
        >
          <v-icon
            small
            class="mr-2"
          >
            mdi-content-save
          </v-icon> {{ $t('m.save') }}
        </v-btn>

        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>

      <v-divider />

      <v-card
        flat
        tile
        class="py-3 px-2"
        :height="workspaceCardHeight"
        style="overflow-y:auto;"
      >
        <v-card
          class=""
          :disabled="viewFlag"
          flat
          tile
        >
          <BaseInfo :model="model" />
        </v-card>

        <v-card
          class="mt-6"
          :disabled="viewFlag"
          flat
          tile
        >
          <SpeedAndFuel :model="model" />
        </v-card>

        <v-card
          class="mt-6"
          :disabled="viewFlag"
          flat
          tile
        >
          <SupplementPad :model="model" />
        </v-card>
      </v-card>
    </v-card> <!-- end 最外层 card -->

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import BaseInfo from '@/components/ship/BaseInfo'
import SpeedAndFuel from '@/components/ship/SpeedAndFuel'
import SupplementPad from '@/components/ship/SupplementPad'

export default {
  name: 'ShipInfoEditDialog',
  components: {
    BaseInfo, SpeedAndFuel, SupplementPad
  },
  props: [
    'visible', 'shipID', 'enterViewFlag'
  ],
  data () {
    return {
      dialog: false,
      dialogTitle: null,
      isLoading: false,
      btnDisabled: false,
      model: null,
      viewFlag: false,

      snackbar: false,
      snackbarText: null
    }
  },
  computed: {
    workspaceCardHeight () {
      if (this.$vuetify.breakpoint.height > 859) {
        return 'auto'
      }
      return this.$vuetify.breakpoint.height - 150
    }
  },
  watch: {
    visible: function (val) {
      if (this.shipID) {
        this.query(this.shipID)
        this.dialogTitle = this.$t('m.editParticular')
      } else {
        this.clearForm()
        this.dialogTitle = this.$t('m.addParticular')
      }
      this.dialog = val
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    handleCancel () {
      this.dialog = false
      this.$emit('cancel')
    },

    handleToEdit () {
      this.viewFlag = false
    },

    query (shipID) {
      this.isLoading = true
      var json = {
        OperID: Utils.getWithExpiry('operID'),
        ShipID: shipID
      }
      httpClient.post('/SIShipInfoQryNewByShipID', json)
        .then((res) => {
          if (res.data.length > 0) {
            this.model = res.data[0]
            this.resetForm()
          } else {
            this.model = null
          }

          this.isLoading = false
        }).catch((err) => {
          this.isLoading = false
        })
    },

    save () {
      for (const [key, value] of Object.entries(this.$store.state.vessel.baseForm)) {
        if ((this._.isNumber(value) && value == 0) ||
            (this._.isString(value) && this._.trim(value) == '')) {
          this.snackbar = true
          this.snackbarText = this.$t('m.completeBaseVessel')
          return
        }
      }
      this.btnDisabled = true
      this.isLoading = true

      var json = { }
      _.assign(json, this.$store.state.vessel.baseForm)
      _.assign(json, this.$store.state.vessel.fuelForm)
      _.assign(json, this.$store.state.vessel.otherForm)
      json.OperID = Utils.getWithExpiry('operID')
      json.ShipStatus = '0'
      json.DOBallast = json.DOLaden
      json.LSDOBallast = json.LSDOLaden
      console.log(this.$store.state.vessel.fuelForm)
      console.log(json)

      var methodName = '/SIShipInfoAdd'
      if (this.model) {
        json.ShipID = this.model.SHIPID
        json.CorporationID = this.model.CORPORATIONID
        methodName = '/SIShipInfoMod'
      }

      httpClient.post(methodName, json)
        .then((res) => {
          this.snackbar = true
          this.snackbarText = this.$t('m.saveSuccess')
          this.isLoading = false
          this.dialog = false
          this.$emit('save')
        }).catch((err) => {
          this.isLoading = false
        })
    },

    resetForm () {
      if (this.model == null) return

      var baseForm = {}; var fuelForm = {}; var otherForm = {}
      for (const [key, value] of Object.entries(this.$store.state.vessel.baseForm)) {
        if (this.model.hasOwnProperty(key.toUpperCase())) {
          baseForm[key] = this.model[key.toUpperCase()]
        }
      }
      for (const [key, value] of Object.entries(this.$store.state.vessel.fuelForm)) {
        if (this.model.hasOwnProperty(key.toUpperCase())) {
          fuelForm[key] = this.model[key.toUpperCase()]
        }
      }
      for (const [key, value] of Object.entries(this.$store.state.vessel.otherForm)) {
        if (this.model.hasOwnProperty(key.toUpperCase())) {
          otherForm[key] = this.model[key.toUpperCase()]
        }
      }

      this.$store.commit('setBaseForm', baseForm)
      this.$store.commit('setFuelForm', fuelForm)
      this.$store.commit('setOtherForm', otherForm)

      if (this.$store.state.vessel.otherForm.SSDate) {
        this.$store.commit('setVesselSSDate',
          dayjs(this.$store.state.vessel.otherForm.SSDate).format('YYYY-MM-D'))
      }
      if (this.$store.state.vessel.otherForm.DDDate) {
        this.$store.state.vessel.otherForm.DDDate =
            dayjs(this.$store.state.vessel.otherForm.DDDate).format('YYYY-MM-D')
      }
    },

    clearForm () {
      this.$store.commit('resetVesselFormEmpty')
    }

  }
}
</script>

<style scoped lang="scss">
  .my-container {
    height: calc(100vh - 48px);
    overflow-y: auto;
  }

</style>
